export const getDisplayOverprice = (price: number, recommendedPrice: number): number => {
  if (!price || !recommendedPrice) return 0;
  const percent = Math.round((price / recommendedPrice) * 100) - 100;
  if (percent > 100) return 95;
  if (percent <= -100) return -95;
  return percent;
};
